import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "refresh",
  "use": "refresh-usage",
  "viewBox": "0 0 192 192",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 192\" id=\"refresh\"><title>ic-refresh</title><g id=\"refresh_refresh\"><g id=\"refresh_expanded-3\" data-name=\"expanded\"><path d=\"M152,112H120a8,8,0,0,0,0,16h11.75a48,48,0,0,1-83.26-25.13,8,8,0,0,0-15.84,2.26A64,64,0,0,0,144,138.29V152a8,8,0,0,0,16,0V120A8,8,0,0,0,152,112Z\" /><path d=\"M40,80H72a8,8,0,0,0,0-16H60.25a48,48,0,0,1,83.26,25.13A8,8,0,0,0,151.42,96a8.74,8.74,0,0,0,1.14-.08,8,8,0,0,0,6.79-9A64,64,0,0,0,48,53.71V40a8,8,0,0,0-16,0V72A8,8,0,0,0,40,80Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/refresh.svg
// module id = 1874
// module chunks = 0